import * as React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import PinCodeScreen from "./PinCodeScreen";

export interface SetPinScreenProps {
  chosenPin: string | null;
  pinValue: string;
  onChange: (pin: string) => void;
}

const SetPinScreen = (props: SetPinScreenProps) => {
  const title =
    props.chosenPin === null
      ? translate(STRINGS.SET_YOUR_4_DIGIT_PIN_CODE)
      : translate(STRINGS.RE_ENTER_YOUR_PIN_CODE);

  return <PinCodeScreen pinValue={props.pinValue} headline={title} onChangePin={props.onChange} />;
};

export default React.memo(SetPinScreen);
